module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/savona.2f50182504392163a0a5def97637d25b.jpg";